import * as Yup from 'yup';

export const FileValidationSchema = Yup.mixed()
  .nullable()
  .test('file-type', 'This type of file is not supported.', file =>
    file.name.match(/\.(doc|docx|pdf|ppt|pptx|zip|rar|gz|xls|xlsx|odt|rtf)+$/i)
  )
  .test(
    'file-size',
    'The file is too big. Max file size is 2MB.',
    file => file.size <= 2 * 1024 * 1024
  );
